@file:OptIn(InternalResourceApi::class)

package quip.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/quip.composeapp.generated.resources/"

public val Res.string.note_import_error_global_quota: StringResource by lazy {
      StringResource("string:note_import_error_global_quota", "note_import_error_global_quota", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12645, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13529, 114),
      ))
    }

public val Res.string.note_import_error_network: StringResource by lazy {
      StringResource("string:note_import_error_network", "note_import_error_network", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12760, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13644, 133),
      ))
    }

public val Res.string.note_import_error_rate_limited: StringResource by lazy {
      StringResource("string:note_import_error_rate_limited", "note_import_error_rate_limited", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12874, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13778, 90),
      ))
    }

public val Res.string.note_import_error_timeout: StringResource by lazy {
      StringResource("string:note_import_error_timeout", "note_import_error_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12949, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13869, 97),
      ))
    }

public val Res.string.note_import_error_too_long: StringResource by lazy {
      StringResource("string:note_import_error_too_long", "note_import_error_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13023, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13967, 86),
      ))
    }

public val Res.string.note_import_error_unavailable: StringResource by lazy {
      StringResource("string:note_import_error_unavailable", "note_import_error_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13098, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14054, 89),
      ))
    }

public val Res.string.note_import_hint: StringResource by lazy {
      StringResource("string:note_import_hint", "note_import_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13176, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14144, 100),
      ))
    }

public val Res.string.note_import_import_all: StringResource by lazy {
      StringResource("string:note_import_import_all", "note_import_import_all", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13281, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14245, 70),
      ))
    }

public val Res.string.note_import_improve_ai: StringResource by lazy {
      StringResource("string:note_import_improve_ai", "note_import_improve_ai", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13352, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14316, 50),
      ))
    }

public val Res.string.note_import_intro: StringResource by lazy {
      StringResource("string:note_import_intro", "note_import_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13403, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14367, 169),
      ))
    }

public val Res.string.note_import_missing_fields: StringResource by lazy {
      StringResource("string:note_import_missing_fields", "note_import_missing_fields", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13577, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14537, 50),
      ))
    }

public val Res.string.note_import_no_results: StringResource by lazy {
      StringResource("string:note_import_no_results", "note_import_no_results", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13632, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14588, 94),
      ))
    }

public val Res.string.note_import_ocr_error_decode: StringResource by lazy {
      StringResource("string:note_import_ocr_error_decode", "note_import_ocr_error_decode", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13731, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14683, 104),
      ))
    }

public val Res.string.note_import_ocr_error_permission: StringResource by lazy {
      StringResource("string:note_import_ocr_error_permission", "note_import_ocr_error_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13832, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14788, 100),
      ))
    }

public val Res.string.note_import_ocr_error_recognition: StringResource by lazy {
      StringResource("string:note_import_ocr_error_recognition", "note_import_ocr_error_recognition", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 13925, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14889, 105),
      ))
    }

public val Res.string.note_import_ocr_error_too_large: StringResource by lazy {
      StringResource("string:note_import_ocr_error_too_large", "note_import_ocr_error_too_large", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14027, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14995, 131),
      ))
    }

public val Res.string.note_import_ocr_error_unsupported: StringResource by lazy {
      StringResource("string:note_import_ocr_error_unsupported", "note_import_ocr_error_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14135, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15127, 133),
      ))
    }

public val Res.string.note_import_ocr_loading: StringResource by lazy {
      StringResource("string:note_import_ocr_loading", "note_import_ocr_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14245, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15261, 59),
      ))
    }

public val Res.string.note_import_part_incomplete: StringResource by lazy {
      StringResource("string:note_import_part_incomplete", "note_import_part_incomplete", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14305, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15321, 111),
      ))
    }

public val Res.string.note_import_pick_image: StringResource by lazy {
      StringResource("string:note_import_pick_image", "note_import_pick_image", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14417, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15433, 50),
      ))
    }

public val Res.string.note_import_pick_maintenance: StringResource by lazy {
      StringResource("string:note_import_pick_maintenance", "note_import_pick_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14464, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15484, 68),
      ))
    }

public val Res.string.note_import_pick_parts: StringResource by lazy {
      StringResource("string:note_import_pick_parts", "note_import_pick_parts", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14533, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15553, 66),
      ))
    }

public val Res.string.note_import_pick_spare_part: StringResource by lazy {
      StringResource("string:note_import_pick_spare_part", "note_import_pick_spare_part", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14604, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15620, 59),
      ))
    }

public val Res.string.note_import_pick_vehicle: StringResource by lazy {
      StringResource("string:note_import_pick_vehicle", "note_import_pick_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14668, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15680, 56),
      ))
    }

public val Res.string.note_import_quote: StringResource by lazy {
      StringResource("string:note_import_quote", "note_import_quote", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14725, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15737, 61),
      ))
    }

public val Res.string.note_import_review_banner: StringResource by lazy {
      StringResource("string:note_import_review_banner", "note_import_review_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14791, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15799, 77),
      ))
    }

public val Res.string.note_import_source_ai: StringResource by lazy {
      StringResource("string:note_import_source_ai", "note_import_source_ai", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14869, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15877, 33),
      ))
    }

public val Res.string.note_import_source_both: StringResource by lazy {
      StringResource("string:note_import_source_both", "note_import_source_both", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14903, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15911, 43),
      ))
    }

public val Res.string.note_import_source_note: StringResource by lazy {
      StringResource("string:note_import_source_note", "note_import_source_note", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14947, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15955, 39),
      ))
    }

public val Res.string.note_import_suggested: StringResource by lazy {
      StringResource("string:note_import_suggested", "note_import_suggested", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 14987, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15995, 41),
      ))
    }

public val Res.string.note_import_title: StringResource by lazy {
      StringResource("string:note_import_title", "note_import_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15029, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16037, 53),
      ))
    }

public val Res.string.note_import_truncated: StringResource by lazy {
      StringResource("string:note_import_truncated", "note_import_truncated", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15079, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16091, 85),
      ))
    }

public val Res.string.note_import_unassigned: StringResource by lazy {
      StringResource("string:note_import_unassigned", "note_import_unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15161, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16177, 50),
      ))
    }

public val Res.string.note_import_use: StringResource by lazy {
      StringResource("string:note_import_use", "note_import_use", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15266, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16286, 31),
      ))
    }

public val Res.string.note_import_use_selection: StringResource by lazy {
      StringResource("string:note_import_use_selection", "note_import_use_selection", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15208, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16228, 57),
      ))
    }

public val Res.string.obligatorio: StringResource by lazy {
      StringResource("string:obligatorio", "obligatorio", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15294, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16318, 35),
      ))
    }

public val Res.string.odometer: StringResource by lazy {
      StringResource("string:odometer", "odometer", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15326, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16354, 28),
      ))
    }

public val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15355, 14),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16383, 14),
      ))
    }

public val Res.string.owner: StringResource by lazy {
      StringResource("string:owner", "owner", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15370, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16398, 29),
      ))
    }

public val Res.string.plate: StringResource by lazy {
      StringResource("string:plate", "plate", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15392, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16428, 29),
      ))
    }

public val Res.string.please_complete_all_required_fields: StringResource by lazy {
      StringResource("string:please_complete_all_required_fields", "please_complete_all_required_fields", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15414, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16458, 111),
      ))
    }

public val Res.string.please_complete_required_fields: StringResource by lazy {
      StringResource("string:please_complete_required_fields", "please_complete_required_fields", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15506, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16570, 99),
      ))
    }

public val Res.string.quantity_label: StringResource by lazy {
      StringResource("string:quantity_label", "quantity_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15594, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16670, 34),
      ))
    }

public val Res.string.quantity_with_unit: StringResource by lazy {
      StringResource("string:quantity_with_unit", "quantity_with_unit", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15629, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16705, 46),
      ))
    }

public val Res.string.rear_above_160: StringResource by lazy {
      StringResource("string:rear_above_160", "rear_above_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15676, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16752, 46),
      ))
    }

public val Res.string.rear_below_160: StringResource by lazy {
      StringResource("string:rear_below_160", "rear_below_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15719, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16799, 46),
      ))
    }

public val Res.string.rear_bulb_type: StringResource by lazy {
      StringResource("string:rear_bulb_type", "rear_bulb_type", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15762, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16846, 46),
      ))
    }

public val Res.string.rear_tire_pressure_above_160: StringResource by lazy {
      StringResource("string:rear_tire_pressure_above_160", "rear_tire_pressure_above_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15801, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16893, 104),
      ))
    }

public val Res.string.rear_tire_pressure_below_160: StringResource by lazy {
      StringResource("string:rear_tire_pressure_below_160", "rear_tire_pressure_below_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15878, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16998, 104),
      ))
    }

public val Res.string.rear_tire_size: StringResource by lazy {
      StringResource("string:rear_tire_size", "rear_tire_size", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15955, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17103, 62),
      ))
    }

public val Res.string.rear_tires: StringResource by lazy {
      StringResource("string:rear_tires", "rear_tires", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 15998, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17166, 46),
      ))
    }

public val Res.string.recommended_fuel: StringResource by lazy {
      StringResource("string:recommended_fuel", "recommended_fuel", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16033, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17213, 56),
      ))
    }

public val Res.string.reference_label: StringResource by lazy {
      StringResource("string:reference_label", "reference_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16082, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17270, 39),
      ))
    }

public val Res.string.reference_optional_label: StringResource by lazy {
      StringResource("string:reference_optional_label", "reference_optional_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16118, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17310, 60),
      ))
    }

public val Res.string.required: StringResource by lazy {
      StringResource("string:required", "required", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16222, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17418, 32),
      ))
    }

public val Res.string.required_field: StringResource by lazy {
      StringResource("string:required_field", "required_field", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16179, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17371, 46),
      ))
    }

public val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16251, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17451, 29),
      ))
    }

public val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16310, 20),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17526, 24),
      ))
    }

public val Res.string.save_vehicle: StringResource by lazy {
      StringResource("string:save_vehicle", "save_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16273, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17481, 44),
      ))
    }

public val Res.string.scan_qr_code: StringResource by lazy {
      StringResource("string:scan_qr_code", "scan_qr_code", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16331, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17551, 48),
      ))
    }

public val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17947, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19307, 28),
      ))
    }

public val Res.string.settings_appearance: StringResource by lazy {
      StringResource("string:settings_appearance", "settings_appearance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16368, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17600, 43),
      ))
    }

public val Res.string.settings_export_data: StringResource by lazy {
      StringResource("string:settings_export_data", "settings_export_data", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16478, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17722, 48),
      ))
    }

public val Res.string.settings_export_data_subtitle: StringResource by lazy {
      StringResource("string:settings_export_data_subtitle", "settings_export_data_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16412, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17644, 77),
      ))
    }

public val Res.string.settings_export_message: StringResource by lazy {
      StringResource("string:settings_export_message", "settings_export_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16523, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17771, 87),
      ))
    }

public val Res.string.settings_export_title: StringResource by lazy {
      StringResource("string:settings_export_title", "settings_export_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16603, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17859, 53),
      ))
    }

public val Res.string.settings_notifications: StringResource by lazy {
      StringResource("string:settings_notifications", "settings_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17218, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18486, 50),
      ))
    }

public val Res.string.settings_notifications_itv: StringResource by lazy {
      StringResource("string:settings_notifications_itv", "settings_notifications_itv", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16753, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17997, 62),
      ))
    }

public val Res.string.settings_notifications_itv_subtitle: StringResource by lazy {
      StringResource("string:settings_notifications_itv_subtitle", "settings_notifications_itv_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16653, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17913, 83),
      ))
    }

public val Res.string.settings_notifications_revision: StringResource by lazy {
      StringResource("string:settings_notifications_revision", "settings_notifications_revision", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16909, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18157, 75),
      ))
    }

public val Res.string.settings_notifications_revision_subtitle: StringResource by lazy {
      StringResource("string:settings_notifications_revision_subtitle", "settings_notifications_revision_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16808, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18060, 96),
      ))
    }

public val Res.string.settings_notifications_spare_part: StringResource by lazy {
      StringResource("string:settings_notifications_spare_part", "settings_notifications_spare_part", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17080, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18328, 77),
      ))
    }

public val Res.string.settings_notifications_spare_part_subtitle: StringResource by lazy {
      StringResource("string:settings_notifications_spare_part_subtitle", "settings_notifications_spare_part_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 16973, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18233, 94),
      ))
    }

public val Res.string.settings_notifications_subtitle: StringResource by lazy {
      StringResource("string:settings_notifications_subtitle", "settings_notifications_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17150, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18406, 79),
      ))
    }

public val Res.string.settings_pressure_unit: StringResource by lazy {
      StringResource("string:settings_pressure_unit", "settings_pressure_unit", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17269, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18537, 54),
      ))
    }

public val Res.string.settings_section_appearance: StringResource by lazy {
      StringResource("string:settings_section_appearance", "settings_section_appearance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17320, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18592, 51),
      ))
    }

public val Res.string.settings_section_data: StringResource by lazy {
      StringResource("string:settings_section_data", "settings_section_data", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17372, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18644, 37),
      ))
    }

public val Res.string.settings_section_debug: StringResource by lazy {
      StringResource("string:settings_section_debug", "settings_section_debug", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17410, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18682, 46),
      ))
    }

public val Res.string.settings_section_preferences: StringResource by lazy {
      StringResource("string:settings_section_preferences", "settings_section_preferences", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17449, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18729, 52),
      ))
    }

public val Res.string.settings_section_session: StringResource by lazy {
      StringResource("string:settings_section_session", "settings_section_session", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17502, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18782, 44),
      ))
    }

public val Res.string.settings_section_user: StringResource by lazy {
      StringResource("string:settings_section_user", "settings_section_user", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17547, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18827, 41),
      ))
    }

public val Res.string.settings_share_log: StringResource by lazy {
      StringResource("string:settings_share_log", "settings_share_log", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17657, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18969, 46),
      ))
    }

public val Res.string.settings_share_log_subtitle: StringResource by lazy {
      StringResource("string:settings_share_log_subtitle", "settings_share_log_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17585, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 18869, 99),
      ))
    }

public val Res.string.settings_sign_out: StringResource by lazy {
      StringResource("string:settings_sign_out", "settings_sign_out", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17868, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19220, 45),
      ))
    }

public val Res.string.settings_sign_out_confirm: StringResource by lazy {
      StringResource("string:settings_sign_out_confirm", "settings_sign_out_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17696, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19016, 53),
      ))
    }

public val Res.string.settings_sign_out_message: StringResource by lazy {
      StringResource("string:settings_sign_out_message", "settings_sign_out_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17742, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19070, 97),
      ))
    }

public val Res.string.settings_sign_out_title: StringResource by lazy {
      StringResource("string:settings_sign_out_title", "settings_sign_out_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17824, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19168, 51),
      ))
    }

public val Res.string.settings_version: StringResource by lazy {
      StringResource("string:settings_version", "settings_version", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17906, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19266, 40),
      ))
    }

public val Res.string.share: StringResource by lazy {
      StringResource("string:share", "share", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17976, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19336, 25),
      ))
    }

public val Res.string.sign_all: StringResource by lazy {
      StringResource("string:sign_all", "sign_all", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 17998, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19362, 32),
      ))
    }

public val Res.string.sign_maintenance: StringResource by lazy {
      StringResource("string:sign_maintenance", "sign_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18304, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19696, 32),
      ))
    }

public val Res.string.sign_maintenance_confirm: StringResource by lazy {
      StringResource("string:sign_maintenance_confirm", "sign_maintenance_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18027, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19395, 40),
      ))
    }

public val Res.string.sign_maintenance_message: StringResource by lazy {
      StringResource("string:sign_maintenance_message", "sign_maintenance_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18068, 180),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19436, 200),
      ))
    }

public val Res.string.sign_maintenance_title: StringResource by lazy {
      StringResource("string:sign_maintenance_title", "sign_maintenance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18249, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19637, 58),
      ))
    }

public val Res.string.spare_part_autofilled: StringResource by lazy {
      StringResource("string:spare_part_autofilled", "spare_part_autofilled", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18337, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19729, 93),
      ))
    }

public val Res.string.spare_part_category: StringResource by lazy {
      StringResource("string:spare_part_category", "spare_part_category", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18721, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20137, 43),
      ))
    }

public val Res.string.spare_part_category_battery: StringResource by lazy {
      StringResource("string:spare_part_category_battery", "spare_part_category_battery", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18419, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19823, 47),
      ))
    }

public val Res.string.spare_part_category_brakes: StringResource by lazy {
      StringResource("string:spare_part_category_brakes", "spare_part_category_brakes", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18467, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19871, 42),
      ))
    }

public val Res.string.spare_part_category_filters: StringResource by lazy {
      StringResource("string:spare_part_category_filters", "spare_part_category_filters", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18510, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19914, 47),
      ))
    }

public val Res.string.spare_part_category_lights: StringResource by lazy {
      StringResource("string:spare_part_category_lights", "spare_part_category_lights", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18558, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 19962, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("note_import_error_global_quota", Res.string.note_import_error_global_quota)
  map.put("note_import_error_network", Res.string.note_import_error_network)
  map.put("note_import_error_rate_limited", Res.string.note_import_error_rate_limited)
  map.put("note_import_error_timeout", Res.string.note_import_error_timeout)
  map.put("note_import_error_too_long", Res.string.note_import_error_too_long)
  map.put("note_import_error_unavailable", Res.string.note_import_error_unavailable)
  map.put("note_import_hint", Res.string.note_import_hint)
  map.put("note_import_import_all", Res.string.note_import_import_all)
  map.put("note_import_improve_ai", Res.string.note_import_improve_ai)
  map.put("note_import_intro", Res.string.note_import_intro)
  map.put("note_import_missing_fields", Res.string.note_import_missing_fields)
  map.put("note_import_no_results", Res.string.note_import_no_results)
  map.put("note_import_ocr_error_decode", Res.string.note_import_ocr_error_decode)
  map.put("note_import_ocr_error_permission", Res.string.note_import_ocr_error_permission)
  map.put("note_import_ocr_error_recognition", Res.string.note_import_ocr_error_recognition)
  map.put("note_import_ocr_error_too_large", Res.string.note_import_ocr_error_too_large)
  map.put("note_import_ocr_error_unsupported", Res.string.note_import_ocr_error_unsupported)
  map.put("note_import_ocr_loading", Res.string.note_import_ocr_loading)
  map.put("note_import_part_incomplete", Res.string.note_import_part_incomplete)
  map.put("note_import_pick_image", Res.string.note_import_pick_image)
  map.put("note_import_pick_maintenance", Res.string.note_import_pick_maintenance)
  map.put("note_import_pick_parts", Res.string.note_import_pick_parts)
  map.put("note_import_pick_spare_part", Res.string.note_import_pick_spare_part)
  map.put("note_import_pick_vehicle", Res.string.note_import_pick_vehicle)
  map.put("note_import_quote", Res.string.note_import_quote)
  map.put("note_import_review_banner", Res.string.note_import_review_banner)
  map.put("note_import_source_ai", Res.string.note_import_source_ai)
  map.put("note_import_source_both", Res.string.note_import_source_both)
  map.put("note_import_source_note", Res.string.note_import_source_note)
  map.put("note_import_suggested", Res.string.note_import_suggested)
  map.put("note_import_title", Res.string.note_import_title)
  map.put("note_import_truncated", Res.string.note_import_truncated)
  map.put("note_import_unassigned", Res.string.note_import_unassigned)
  map.put("note_import_use", Res.string.note_import_use)
  map.put("note_import_use_selection", Res.string.note_import_use_selection)
  map.put("obligatorio", Res.string.obligatorio)
  map.put("odometer", Res.string.odometer)
  map.put("ok", Res.string.ok)
  map.put("owner", Res.string.owner)
  map.put("plate", Res.string.plate)
  map.put("please_complete_all_required_fields", Res.string.please_complete_all_required_fields)
  map.put("please_complete_required_fields", Res.string.please_complete_required_fields)
  map.put("quantity_label", Res.string.quantity_label)
  map.put("quantity_with_unit", Res.string.quantity_with_unit)
  map.put("rear_above_160", Res.string.rear_above_160)
  map.put("rear_below_160", Res.string.rear_below_160)
  map.put("rear_bulb_type", Res.string.rear_bulb_type)
  map.put("rear_tire_pressure_above_160", Res.string.rear_tire_pressure_above_160)
  map.put("rear_tire_pressure_below_160", Res.string.rear_tire_pressure_below_160)
  map.put("rear_tire_size", Res.string.rear_tire_size)
  map.put("rear_tires", Res.string.rear_tires)
  map.put("recommended_fuel", Res.string.recommended_fuel)
  map.put("reference_label", Res.string.reference_label)
  map.put("reference_optional_label", Res.string.reference_optional_label)
  map.put("required", Res.string.required)
  map.put("required_field", Res.string.required_field)
  map.put("retry", Res.string.retry)
  map.put("save", Res.string.save)
  map.put("save_vehicle", Res.string.save_vehicle)
  map.put("scan_qr_code", Res.string.scan_qr_code)
  map.put("settings", Res.string.settings)
  map.put("settings_appearance", Res.string.settings_appearance)
  map.put("settings_export_data", Res.string.settings_export_data)
  map.put("settings_export_data_subtitle", Res.string.settings_export_data_subtitle)
  map.put("settings_export_message", Res.string.settings_export_message)
  map.put("settings_export_title", Res.string.settings_export_title)
  map.put("settings_notifications", Res.string.settings_notifications)
  map.put("settings_notifications_itv", Res.string.settings_notifications_itv)
  map.put("settings_notifications_itv_subtitle", Res.string.settings_notifications_itv_subtitle)
  map.put("settings_notifications_revision", Res.string.settings_notifications_revision)
  map.put("settings_notifications_revision_subtitle", Res.string.settings_notifications_revision_subtitle)
  map.put("settings_notifications_spare_part", Res.string.settings_notifications_spare_part)
  map.put("settings_notifications_spare_part_subtitle", Res.string.settings_notifications_spare_part_subtitle)
  map.put("settings_notifications_subtitle", Res.string.settings_notifications_subtitle)
  map.put("settings_pressure_unit", Res.string.settings_pressure_unit)
  map.put("settings_section_appearance", Res.string.settings_section_appearance)
  map.put("settings_section_data", Res.string.settings_section_data)
  map.put("settings_section_debug", Res.string.settings_section_debug)
  map.put("settings_section_preferences", Res.string.settings_section_preferences)
  map.put("settings_section_session", Res.string.settings_section_session)
  map.put("settings_section_user", Res.string.settings_section_user)
  map.put("settings_share_log", Res.string.settings_share_log)
  map.put("settings_share_log_subtitle", Res.string.settings_share_log_subtitle)
  map.put("settings_sign_out", Res.string.settings_sign_out)
  map.put("settings_sign_out_confirm", Res.string.settings_sign_out_confirm)
  map.put("settings_sign_out_message", Res.string.settings_sign_out_message)
  map.put("settings_sign_out_title", Res.string.settings_sign_out_title)
  map.put("settings_version", Res.string.settings_version)
  map.put("share", Res.string.share)
  map.put("sign_all", Res.string.sign_all)
  map.put("sign_maintenance", Res.string.sign_maintenance)
  map.put("sign_maintenance_confirm", Res.string.sign_maintenance_confirm)
  map.put("sign_maintenance_message", Res.string.sign_maintenance_message)
  map.put("sign_maintenance_title", Res.string.sign_maintenance_title)
  map.put("spare_part_autofilled", Res.string.spare_part_autofilled)
  map.put("spare_part_category", Res.string.spare_part_category)
  map.put("spare_part_category_battery", Res.string.spare_part_category_battery)
  map.put("spare_part_category_brakes", Res.string.spare_part_category_brakes)
  map.put("spare_part_category_filters", Res.string.spare_part_category_filters)
  map.put("spare_part_category_lights", Res.string.spare_part_category_lights)
}
